// import { topicList,topicProductList } from '../../api/topic'

// initial state
const state = {
	// topicInfo: {},
	// topicAllProducts: [],
	// currentItemCategory: {}	// 当前选中的专题内产品分类
}

// mutations
const mutations = {
	// saveTopicInfo(state, data) {
	// 	state.topicInfo = data
	// },
	// saveTopicAllProducts(state, data) {
	// 	state.topicAllProducts = data
	// },
	// saveCurrentItemCategory(state, data){
	// 	state.currentItemCategory = data
	// },
  // resetCurrentItemCategory(state) {
  //   if (state.topicAllProducts && state.topicAllProducts.length) {
  //     state.currentItemCategory = state.topicAllProducts[0]
  //   }
  // },
}

// actions 
const actions = {
	// fetchTopicInfo({ commit, state }, params) {
	// 	return new Promise((resolve, reject) => {
	// 		topicList(params.display_area,params.page, params.per_page,params.topic_id).then(
	// 			response => {
	// 				if (response) {
	// 					commit('saveTopicInfo', response.topic[0])
	// 				}
	// 				resolve(response)
	// 			},
	// 			error => {
	// 				reject(error)
	// 			}
	// 		)
	// 	})
	// },
	// fetchTopicAllProduct({ commit, state }, params) {
	// 	return new Promise((resolve, reject) => {
	// 		// topicList(params.display_area,params.page, params.per_page,params.topic_id).then(
	// 		topicProductList(params.topic_id, params.page, params.per_page, params.by_category).then(
	// 			response => {
	// 				if (response) {
	// 					commit('saveTopicAllProducts', response.dataList)
	// 					commit('resetCurrentItemCategory')
	// 				}
	// 				resolve(response)
	// 			},
	// 			error => {
	// 				reject(error)
	// 			}
	// 		)
	// 	})
	// }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/topic.js